import { Injectable } from '@angular/core';

import { SwUpdate } from '@angular/service-worker';
import { ConfirmationService } from 'primeng/api';
import { interval } from 'rxjs';

/**
 * This service checks for new updates in the application.
 */
@Injectable({ providedIn: 'root' })
export class CheckUpdateService {
  constructor(public readonly updates: SwUpdate, private readonly confirmationService: ConfirmationService) {}

  public checkForUpdates(): void {
    this.updates.versionUpdates.subscribe((event) => this.promptUser(event));

    if (this.updates.isEnabled) {
      this.updates.activateUpdate();
      interval(2000 * 60).subscribe(() => {
        // 2 minutes, check update every 2 minute
        this.updates.checkForUpdate().then();
      });
    }
  }

  private promptUser(e: any): void {
    switch (e.type) {
      case 'VERSION_DETECTED':
        break;
      case 'VERSION_READY':
        this.confirmationService.confirm({
          key: 'version-update',
          message: 'The newer version of the application is available. Do you wish to get it now?',
          header: 'Updates Available',
          defaultFocus: 'accept',
          icon: `pi pi-sync`,
          acceptLabel: 'Yes',
          rejectLabel: 'No',
          acceptIcon: 'pi pi-check me-2',
          rejectIcon: 'pi pi-times me-2',
          rejectButtonStyleClass: 'p-button-secondary',
          acceptButtonStyleClass: 'p-button-primary',
          accept: () => {
            this.updates.activateUpdate().then(() => window.location.reload());
            window.location.reload();
          },
          reject: () => {
            this.confirmationService.close();
          },
        });
        break;
      case 'VERSION_INSTALLATION_FAILED':
        break;
    }
  }
}
